import { render } from "./CarouselDesempenho.vue?vue&type=template&id=6487e960"
import script from "./CarouselDesempenho.vue?vue&type=script&lang=js"
export * from "./CarouselDesempenho.vue?vue&type=script&lang=js"
script.render = render

export default script